"use strict";

require("./..\\..\\..\\bower_components\\parsleyjs\\dist\\parsley.js");
require('../../../bower_components/parsleyjs/src/i18n/ru');

var lang = $('html').attr('lang');

if(lang) window.ParsleyValidator.setLocale(lang);